export default {
  HIPROJECTS: 'HIPROJECTS',
  MODERATION: 'MODERATION',
  INVITE_ANIMATION: 'INVITE_ANIMATION',
  WAITING_FOR_CONNECTION: 'WAITING_FOR_CONNECTION',
  NEEDS_MORE_INFO: 'NEEDS_MORE_INFO',
  CONNECTED: 'CONNECTED',
  HIRED: 'HIRED',
  DIRECT_ENQ_WAITING: 'DIRECT_ENQ_WAITING',
  CLOSED: 'CLOSED',
  HIRED_CLOSED: 'HIRED_CLOSED',
  CONNECTED_CLOSED: 'CONNECTED_CLOSED'
};
